export const reorder = <T>(list: T[], startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

export const filterAndSort = <T extends { name: string }>(list: T[], searchQuery: string, sortBy: 'asc' | 'desc' | 'none') => {
    const sortedList = [...list];
    const normalizedQuery = searchQuery.toLowerCase();

    if (sortBy === 'asc') {
        return sortedList.sort((a, b) => a.name.localeCompare(b.name)).filter((el) => el.name.toLowerCase().includes(normalizedQuery));
    }
    if (sortBy === 'desc') {
        return sortedList.sort((a, b) => b.name.localeCompare(a.name)).filter((el) => el.name.toLowerCase().includes(normalizedQuery));
    }

    return list.filter((el) => el.name.toLowerCase().includes(normalizedQuery));
};
